import React, { useEffect } from 'react'

import Hero from './Components/HeroSection/Hero'
import CarsSlider from './Components/CarSlider/CarsSlider'
import Career from "./Components/Career/Career"
import News from "./Components/News/News"

import Carsel from './Components/Carsel/Carsel'
import Success from './Components/Success/Success'

import { getCarsAPI } from "../../API/Cars"
import { useDispatch } from "react-redux"
import { addCars } from "../../GlobalStore/actions/carActions"
import { ToastContainer, toast } from 'react-toastify';

import "./Home.scss"
import Shopnow from '../../Components/Shopnow/Shopnow'




const Home = () => {
  let dispatch = useDispatch()


  const gettingCars = async () => {
    let res = await getCarsAPI()
    if (res.error != null) {
      toast.error(res.error, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch(addCars(res.data.data))
    }
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    gettingCars()
  }, [])
  return (
    <>
      <div className="home_container">
        <Hero />
        <CarsSlider />
        <Carsel />
        <Success />
        <Career />
        <Shopnow />
        <News />
      </div>
    </>
  )
}

export default Home